import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Selection } from '../Common/selection';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import ContentWrapper from '../Layout/ContentWrapper';
import { InputField } from '../Common/inputField';

const fixingStatus = [
  { label: 'UNRECEIVED', value: 'UNRECEIVED' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'REPAIRING', value: 'REPAIRING' },
  { label: 'REPAIRED', value: 'REPAIRED' },
  { label: 'DISPATCHED', value: 'DISPATCHED' },
];

// const serviceType = [
//   { label: 'External Customer Return', value: 'External Customer Return' },
//   { label: 'Retailer Return', value: 'Retailer Return' },
// ];

const booleanOptions = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

class RMAForm extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      Submit_Description1: '',
      Submit_Description2: '',
      onCustomerEditPage: undefined,
    };
  }

  componentDidMount() {
    if(this.props.route.path === 'customerRMA/:id' || this.props.route.path === 'customerRMA/new') {
      this.setState({
        onCustomerEditPage: true
      })
    }else {
      this.setState({
        onCustomerEditPage: false
      })
    }
    this.props.routeParams.id && this.props.fetchCustomerReturn(this.props.routeParams.id); //If the route contains id search return by id
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.Submit_Description1 !== this.props.Submit_Description1 ) {
      this.setState({
        Submit_Description1: nextProps.Submit_Description1,
      })
    }
    if(nextProps.Submit_Description2 !== this.props.Submit_Description2 ) {
      this.setState({
        Submit_Description2: nextProps.Submit_Description2,
      })
    }
  }

  breadcrumb = () => (
    <Breadcrumb style={this.state.crumbStyle}>
      <Breadcrumb.Item>
        <Translate value="rma" />
      </Breadcrumb.Item>
      <Breadcrumb.Item active="true">
       <Translate value="Return_Form" />
      </Breadcrumb.Item>
    </Breadcrumb>
  )
  breadCrumbButton = () => (
    <ButtonToolbar>
      <Button
        bsStyle="success"
        type="submit"
        action="submit"
      >
        <em className="fa fa-save" /><Translate value="save" />
      </Button>
      <Button
        bsStyle="danger"
        type="reset"
        href={this.state.onCustomerEditPage ? '/customerRMA' : '/dispatchRMA'}
      >
        <em className="fa fa-close" /><Translate value="cancel" />
      </Button>
    </ButtonToolbar>
  )

  handleTextareaChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleFormSubmit = (formValues) => {
    if(this.props.currentReturnDetail) this.props.editCustomerReturn({ ...formValues, ...this.state,  });
    else{
      this.props.createCustomerReturn({ ...formValues, ...this.state });
    }
  }

  render() {
    const returnDetail = (<h2><Translate value="return_details" /></h2>);
    const repairDetail = (<h2><Translate value="repair_detail" /></h2>);
    const shippingDetail = (<h2><Translate value="shipping_detail" /></h2>);
    const { handleSubmit, submitting, pristine, Fix_Status } = this.props;
    const FixStatusIsUnreceived = Fix_Status === "UNRECEIVED" || !Fix_Status;
    return(
    <ContentWrapper>
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
        {this.breadcrumb()} {/* BreadCrumb */}
        {this.breadCrumbButton()} {/* Breadcrumb Buttons */}
        <Grid id="vendor-form">{/* Return Details start */}
          <Row>
            <Col sm={12}>
              <Panel header={returnDetail}>
                <Row>{/* First 2 Rows */}
                  <Col sm={6}>
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-4"><Translate value="Customer_Name" /><span className="asteriksReq">*</span></label>
                        <div className="col-sm-7">
                          <Field name="Customer_Name" component={InputField} disabled={!FixStatusIsUnreceived} />
                        </div>
                      </div>
                    </Row>
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-4"><Translate value="Customer_Mobile" /></label>
                        <div className="col-sm-7">
                          <Field name="Customer_Mobile" component={InputField} disabled={!FixStatusIsUnreceived} />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col sm={6}>
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-4"><Translate value="Customer_Address" /></label>
                        <div className="col-sm-7">
                          <Field name="Customer_Address" component={InputField} disabled={!FixStatusIsUnreceived} />
                        </div>
                      </div>
                    </Row>
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-4"><Translate value="Customer_Email" /></label>
                        <div className="col-sm-7">
                          <Field name="Customer_Email" component={InputField} disabled={!FixStatusIsUnreceived} />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>{/* First 2 Rows Ends */}
                <Row>{/* Second 2 Rows */}
                  <Col sm={4}>
                    <div className="form-group">
                      <label><Translate value="RMA_Content" /><span className="asteriksReq">*</span></label>
                      <Field name="RMA_Content" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="RMA_Service_Type" /></label>
                      <Field name="RMA_Service_Type" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                  </Col>
                  <Col sm={4}>
                    <div className="form-group">
                      <label><Translate value="RMA_Number" /><span className="asteriksReq">*</span></label>
                      <Field name="RMA_Num" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Product_Serial_Number" /><span className="asteriksReq">*</span></label>
                      <Field name="Product_SN" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                  </Col>
                  <Col sm={4}>
                    <div>
                      <label><Translate value="Product_Model" /><span className="asteriksReq">*</span></label>
                      <Field name="Product_Model" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                    <Row style={{ marginTop: 10 }}>
                      <Col sm={6} >
                        <label><Translate value="Is_Urgent" /></label>
                        <Field name="Is_Urgent" component={Selection} options={booleanOptions} disabled={!FixStatusIsUnreceived} />
                      </Col>
                      <Col sm={6}>
                        <label ><Translate value="Is_Warranty" /><span className="asteriksReq">*</span></label>
                        <Field name="Is_Warranty" component={Selection} options={booleanOptions} disabled={!FixStatusIsUnreceived} />
                      </Col>
                    </Row>
                  </Col>
                </Row>{/* Second 2 Rows Ends */}
                <Row>{/* 3rd 2 Rows */}
                  <Col sm={4}>
                    <div className="form-group">
                      <label><Translate value="Product_Description" /><span className="asteriksReq">*</span></label>
                      <Field name="Product_Description" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Return_Logistics_Company" /></label>
                      <Field name="Return_Logitics_Company" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Return_Tracking_Number" /></label>
                      <Field name="Return_Tracking_Num" component={InputField} disabled={!FixStatusIsUnreceived} />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="form-group">
                      <label className="col-sm-6" htmlFor="textarea1"><Translate value="notes" />1</label>
                      <label className="col-sm-6" htmlFor="textarea2"><Translate value="notes" />2</label>
                      <div className="col-sm-6">
                        <textarea onChange={this.handleTextareaChange} value={this.state.Submit_Description1} name="Submit_Description1" className="form-control" id="textarea1" style={{ width: 260, height: 128 }} />
                      </div>
                      <div className="col-sm-6">
                        <textarea onChange={this.handleTextareaChange} value={this.state.Submit_Description2} name="Submit_Description2" className="form-control" id="textarea2" style={{ width: 260, height: 128 }} />
                      </div>
                    </div>
                  </Col>
                </Row>{/* 3rd 2 Rows Ends */}
              </Panel>
            </Col> {/* End Return Details */}
            <Col sm={6}>
              <Panel header={repairDetail}>
                <Row>
                  <Col sm={6}>
                    <div className="form-group">
                      <label><Translate value="Openbox_Description" /></label>
                      <Field name="Openbox_Description" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Product_Detail_Info" /></label>
                      <Field name="Product_Detail_Info" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Warehouse_Check_Info" /></label>
                      <Field name="Warehouse_Check_Info" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="form-group">
                      <label><Translate value="Status" /></label>
                      <Field name="Fix_Status" component={Selection} options={fixingStatus} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Repair_Note" />1</label>
                      <Field name="Fix_Description1" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Repair_Note" />2</label>
                      <Field name="Fix_Description2" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col sm={6}>
              <Panel header={shippingDetail}>
                <Row>
                  <Col sm={6}>
                    <div className="form-group">
                      <label><Translate value="Dispatch_Logistics_Company" /></label>
                      <Field name="Dispatch_Logiticis_Company" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Dispatch_Tracking_Number" /></label>
                      <Field name="Dispatch_Tracking_Num" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Shipping_Cost" /></label>
                      <Field name="Dispatch_Fee" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    {/* <div className="form-group">
                      <label><Translate value="Dispatch_Date" /></label>
                      <Field name="Dispatch_Date" component={InputField} disabled={onCustomerEditPage} />
                    </div> */}
                  </Col>
                  <Col sm={6}>
                    <div className="form-group">
                      <label><Translate value="Status" /></label>
                      <Field name="Fix_Status" component={Selection} options={fixingStatus} disabled={this.state.onCustomerEditPage} />
                    </div>
                    {/* <div className="form-group">
                      <label><Translate value="Person_Dispatch" /></label>
                      <Field name="Person_Dispatch" component={InputField} disabled={onCustomerEditPage} />
                    </div> */}
                    <div className="form-group">
                      <label><Translate value="Dispatch_Description" />1</label>
                      <Field name="Dispatch_Description1" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                    <div className="form-group">
                      <label><Translate value="Dispatch_Description" />2</label>
                      <Field name="Dispatch_Description2" component={InputField} disabled={this.state.onCustomerEditPage} />
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </form>
    </ContentWrapper>);
  }
}

export default RMAForm;



// WEBPACK FOOTER //
// ./master/jsx/components/RMA/rmaForm.jsx